import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import underscore from "vue-underscore";
import "sweetalert2/dist/sweetalert2.min.css";
import VueCookie from "vue-cookie";
import InstantSearch from "vue-instantsearch";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
import { setupComponents } from "@/config/setup-components";
import mixpanel from "mixpanel-browser";
import api from "./plugins/axios";
import global from "@/mixins/global.js";

setupComponents(Vue);

Vue.prototype.$_ = underscore;
Vue.prototype.$axios = api;
Vue.prototype.$mixpanel = mixpanel;
Vue.prototype.$mixpanel.init(process.env.MIX_PANEL_TOKEN);
Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${VueCookie.get(
  "token"
)}`;
Vue.prototype.$axios.defaults.headers.common["Content-Type"] =
  "application/json";

Vue.use(VueSweetalert2);
Vue.use(underscore);
Vue.use(InstantSearch);
Vue.use(VueTelInputVuetify, {
  vuetify
});
Vue.use(VueAxios, axios);
Vue.mixin(global);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
